import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { PhoneNumberValue } from 'src/app/shared/components/phone-number-input/phone-number-input.component';
import { ApiService } from 'src/app/shared/services/api.service';

export interface UserIdentity {
  username: string;
  email?: boolean;
  phone?: boolean;
}

export interface UserIdentityValidation {
  valid: boolean;
  errorMessage?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  #api = inject(ApiService);
  #logger = inject(NGXLogger);
  #translate = inject(TranslateService);

  async resolveUserIdentity(
    active: number,
    email: string,
    mobile: PhoneNumberValue | null,
  ): Promise<UserIdentity | undefined> {
    if (active === 1) {
      const username = email.toLowerCase().trim();
      const { available } = await this.#api.isEmailAvailable(username);
      return { username, email: available, phone: true };
    } else if (active === 2) {
      const username = mobile?.e164Number;
      const { available } = await this.#api.isMobileNumberAvailable(username);
      return { username, phone: available, email: true };
    }
    return undefined;
  }

  validateUserIdentity(userDetails: UserIdentity | undefined, active: number): UserIdentityValidation {
    if (!userDetails) {
      const message = this.#translate.instant('MESSAGES.ERRORS.INVALID_ACTIVE_TAB');
      this.#logger.error(message, active);
      return { valid: false, errorMessage: message };
    }

    if (!userDetails.username) {
      const message = this.#translate.instant('MESSAGES.ERRORS.INVALID_USERNAME');
      this.#logger.error(message);
      return { valid: false, errorMessage: message };
    }

    if (userDetails.email === true && userDetails.phone === true) {
      const message = this.#translate.instant('MESSAGES.ERRORS.USER_NOT_FOUND');
      this.#logger.error(message);
      return { valid: false, errorMessage: message };
    }

    return { valid: true };
  }
}
